import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UsersComponent} from './users/users.component';
import {RouterModule} from "@angular/router";
import {NxGridModule} from "@allianz/ng-aquila/grid";
import {ComponentsModule} from "../../components/components.module";
import {NxListModule} from "@allianz/ng-aquila/list";
import {NxTabsModule} from "@allianz/ng-aquila/tabs";
import {NxHeadlineModule} from "@allianz/ng-aquila/headline";
import {NxIconModule} from "@allianz/ng-aquila/icon";
import {NxFormfieldModule} from "@allianz/ng-aquila/formfield";
import {NxInputModule} from "@allianz/ng-aquila/input";
import {FormsModule} from "@angular/forms";
import {NxDropdownModule} from "@allianz/ng-aquila/dropdown";
import {NxPhoneInputModule} from "@allianz/ng-aquila/phone-input";
import {NxButtonModule} from "@allianz/ng-aquila/button";
import {TranslateModule} from "@ngx-translate/core";
import {EditUsersComponent} from './edit-users/edit-users.component';
import {ShowUsersComponent} from './show-users/show-users.component';
import {NxCheckboxModule} from "@allianz/ng-aquila/checkbox";
import {NxRadioModule} from "@allianz/ng-aquila/radio-button";
import {NxCardModule} from "@allianz/ng-aquila/card";
import {NxTableModule} from "@allianz/ng-aquila/table";
import {PipeModule} from "../../pipe/pipe.module";
import {NxDataDisplayModule} from "@allianz/ng-aquila/data-display";

@NgModule({
  declarations: [
    UsersComponent,
    EditUsersComponent,
    ShowUsersComponent
  ],
    imports: [
        CommonModule,
        RouterModule,
        NxGridModule,
        ComponentsModule,
        NxListModule,
        NxTabsModule,
        NxHeadlineModule,
        NxIconModule,
        NxFormfieldModule,
        NxInputModule,
        FormsModule,
        NxDropdownModule,
        NxPhoneInputModule,
        NxButtonModule,
        TranslateModule,
        NxCheckboxModule,
        NxRadioModule,
        NxCardModule,
        NxTableModule,
        PipeModule,
        NxDataDisplayModule,
    ]
})
export class UserModule {
}
